import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=007af3c0&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007af3c0",
  null
  
)

export default component.exports